const initialState = {
  data: null,
};

const warrantyDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_WARRANTY_DATA':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default warrantyDataReducer;
